// Dependencies
require("webstrap/type");
require("grid");
require("webstrap/responsive-utilities");

// Element
require("element/avantage");

// Styles
require("./avantages.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/avantages/index.js
 ** module id = 126
 ** module chunks = 0 1
 **/